/**
 * MainPlaceholderTile — Plan 05-12 Task 1.
 *
 * Card chrome + 2-line muted text. No KPI value, no chart, no chip, no tooltip.
 *
 * Used for:
 *   - Phase-2 deferred Campaign Metrics rows
 *   - xlsx "Not trackable currently" rows (e.g. Demos completed/week)
 *   - ROI tiles with missing optional Finance upload columns
 *   - Any API response with placeholder_text non-null
 *
 * Per UI-SPEC §"MainPlaceholderTile anatomy" (identical Card chrome, no drilldown).
 */
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card.js';

interface MainPlaceholderTileProps {
  title: string;
  /** Primary muted line (text-sm text-ink-700) */
  primary: string;
  /** Secondary italic line (text-xs italic text-ink-500) — optional */
  secondary?: string;
}

export function MainPlaceholderTile({
  title,
  primary,
  secondary,
}: MainPlaceholderTileProps): React.JSX.Element {
  return (
    <Card>
      <CardHeader>
        <CardTitle
          className="text-[0.72rem] uppercase tracking-wider font-semibold text-ink-600"
          data-testid="placeholder-title"
        >
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p
          className="text-sm text-ink-700"
          data-testid="placeholder-primary"
        >
          {primary}
        </p>
        {secondary && (
          <p
            className="mt-1 text-xs italic text-ink-500"
            data-testid="placeholder-secondary"
          >
            {secondary}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
